export const prendimiento = {
	nombre: "Prendimiento",
	dia: "Lunes Santo",
	nombrecompleto:
		"Real Congregación de la Vela y Mayor Culto al Santísimo Sacramento. Franciscana y Carmelitana Hermandad de Penitencia de Nuestro Padre Jesús en su Prendimiento, María Santísima del Patrocinio y Beato Fray Diego José de Cádiz",
	sede: "Capilla del Beato Diego José de Cádiz",
	pasos: 2,
	distancia: [1550, 1410],
	penitentes: 240,
	cargadores: 126,
	web:
		"http://www.diariodecadiz.es/semana_santa/Prendimiento_0_1229277800.html",

	ida: [
		{ lng: -6.2997016, lat: 36.5372584 },
		{ lng: -6.2995487, lat: 36.5374415 },
		{ lng: -6.2989828, lat: 36.5370342 },
		{ lng: -6.2996829, lat: 36.5358037 },
		{ lng: -6.2976766, lat: 36.535058 },
		{ lng: -6.2969363, lat: 36.5347865 },
		{ lng: -6.2966815, lat: 36.534655 },
		{ lng: -6.2963281, lat: 36.5343123 },
		{ lng: -6.2960672, lat: 36.5344438 },
		{ lng: -6.2958232, lat: 36.5344093 },
		{ lng: -6.2921914, lat: 36.5302541 },
		{ lng: -6.2928137, lat: 36.529767 },
		{ lng: -6.2933019, lat: 36.5297325 },
		{ lng: -6.2945035, lat: 36.529642 },
		{ lng: -6.2946135, lat: 36.5295601 },
		{ lng: -6.2951446, lat: 36.5295083 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957051, lat: 36.5291053 },
		{ lng: -6.2954101, lat: 36.5297583 },
		{ lng: -6.2956622, lat: 36.5299523 },
		{ lng: -6.2952854, lat: 36.5303478 },
		{ lng: -6.2950172, lat: 36.5308327 },
		{ lng: -6.2949206, lat: 36.5308371 },
		{ lng: -6.294926, lat: 36.531461 },
		{ lng: -6.2964602, lat: 36.5317714 },
		{ lng: -6.2964025, lat: 36.5318479 },
		{ lng: -6.2967941, lat: 36.5325418 },
		{ lng: -6.2971522, lat: 36.5330612 },
		{ lng: -6.2984625, lat: 36.5343339 },
		{ lng: -6.2989694, lat: 36.5338845 },
		{ lng: -6.3009167, lat: 36.5354567 },
		{ lng: -6.2994388, lat: 36.5373187 },
		{ lng: -6.2995461, lat: 36.5373855 },
		{ lng: -6.2996721, lat: 36.537239 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-26T16:05",
			latlng: [36.53722, -6.29969]
		},
		{
			name: "Nueva",
			hora: "2018-03-26T18:40",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-26T19:40",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-26T20:40",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-26T21:05",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-26T21:15",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Alameda Marqués de Comillas",
			"Vea Murguía",
			"Plaza Mina",
			"Tinte",
			"Plaza San Francisco",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		[
			"Ancha",
			"San Jose (Izq.)",
			"Cervantes (Dcha.)",
			"Plaza del Mentidero",
			"Bendición de Dios",
			"Alameda Marqués de Comillas"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/prendimiento.js